export default class StaticConfig {
  static Context = {
    Country: {},
    ssoCountry: {},
    ComponentConfig: {},
    UserType: {},
    FileArray: new FormData(),

    // flag to control search capabilities as per country configurations
    // can be turned off for UAT to test behavior for every country
    switchOn: true,

    // A reference to the digital assistant. This allows ProductDetails.js to open
    // the assistant by calling BotAssistant.openFromExternalComponent().
    assistantRef: null
  };
}



// WEBPACK FOOTER //
// ./src/mi-app/StaticConfig.js